import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectSede } from 'sharedComponents/select'

const IdSedeOrigenFormGroup = ({ iError, iTouched, fIsSubmitting, flagEditarComentarios }) => {
  return (
    <Form.Group>
      <Form.Label text='ESTABLECIMIENTO ORIGEN' htmlFor='select-sedeOrigen' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idSedeOrigen'>
          {({ field }) => (
            <SelectSede
              {...field}
              id='select-sedeOrigen'
              disabled={fIsSubmitting || flagEditarComentarios}
              isInvalid={iTouched && iError}
              titulo='Todos'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdSedeOrigenFormGroup)
